import {InquiryMultiField} from "./inquiry_multi_field";

export const AgreementFieldConfig = {
    baseHtmlClass: 'inquiry_field--agreement_accepted',
    selector: '.inquiry_field--agreement_accepted'
}

export class AgreementField extends InquiryMultiField {

    static new(inquiryForm) {
        if (!inquiryForm.element) { return null }
        const element = inquiryForm.element.querySelector(AgreementFieldConfig.selector);
        if (element) { return new AgreementField(element, inquiryForm) }
    }

    constructor(id_or_element, inquiryForm) {
        super(id_or_element, inquiryForm);
    }

    // Returns the single boolean value as calculated by looking at each of the inputs (hidden '0' and checkbox '1').
    getInputsValue() {
        return this.getAgreementAcceptedInputValue();
    }

    typecastValue(value) {
        return this.typecastValueToBoolean(value);
    }

    // Boolean checkbox always has a value.
    hasValue() {
        return true;
    }

    humanValue() {
        return (!!this.value) ? `Agreement accepted` : `Agreement not accepted` ;
    }

    appendErrors() {
        if (this.isRequired() && this.value === false ) { this.errors.push(`The ${ this.label } must be accepted to continue.`) }
    }

    appendWarnings() {
    }


    // Return the hidden input that allows the user to select value '0'.
    getAgreementAcceptedHiddenInput() {
        return this.inputElements.filter((element)=>{ return element.getAttribute('type') === 'hidden' })[0];
    }

    // Return the visible checkbox that allows the user to select value '1'.
    getAgreementAcceptedCheckboxInput() {
        return this.inputElements.filter((element)=>{ return element.getAttribute('type') === 'checkbox' })[0];
    }

    getAgreementAcceptedInput() {
        if (!this.inputElements) { this.setInputElements() }
        const hiddenInput = this.getAgreementAcceptedHiddenInput();
        const checkboxInput = this.getAgreementAcceptedCheckboxInput();
        if (!hiddenInput || !checkboxInput) { return }
        return (checkboxInput.checked === true ? checkboxInput : hiddenInput); // Return the input element that would be passed to the server.
    }

    getAgreementAcceptedInputValue() {
        const input = this.getAgreementAcceptedInput();
        const value = input ? input.value : null;
        return this.typecastValueToBoolean(value);
    }

}